import React from 'react';
import FeaturedImage from '../FeaturedImage';
import PostAuthor from '../PostAuthor';

function post(props) {
  const {
    post,
    postType,
    displayAuthor,
    displayExcerpt,
    displayDate,
    displayCategories,

    replaceSelected,
    theExcerpt
  } = props;

  let categories;
  let categoryItems;
  let featuredImage;
  let author;
  let excerpt;
  let date;

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:featuredmedia')) {
    featuredImage =
      <figure className="eight29-featured-image">
        <FeaturedImage
          imageSize={'eight29_post_thumb'}
          image={post._embedded['wp:featuredmedia']}
          srcset={post.featured_image_srcset}
        ></FeaturedImage>
      </figure>
  } else {
    featuredImage =<div className="eight29-featured-image"></div>
  }

  if (post.hasOwnProperty('_embedded') && post._embedded.hasOwnProperty('wp:term')) {
    categories = post._embedded['wp:term'][0];
  }

  if (categories && displayCategories) {
    categoryItems = categories.map(category => {

    function htmlDecode(inp){
      var replacements = {'&lt;':'<','&gt;':'>','&sol;':'/','&quot;':'"','&apos;':'\'','&amp;':'&','&laquo;':'«','&raquo;':'»','&nbsp;':' ','&copy;':'©','&reg;':'®','&deg;':'°'
                         };
      for(var r in replacements){
        inp = inp.replace(new RegExp(r,'g'),replacements[r]);
      }
      return inp.replace(/&#(\d+);/g, function(match, dec) {
        return String.fromCharCode(dec);
      });
    }

      let catName = htmlDecode(category.name);

      return (
        <span key={category.id}>{catName}</span>
      );
    });
  }

  if (post.author && displayAuthor) {
    author = <PostAuthor
      post={post}
    />
  }

  if (post.excerpt && displayExcerpt) {
    excerpt = <div className="eight29-post-excerpt" dangerouslySetInnerHTML={{__html: theExcerpt(post.excerpt.rendered)}}>
    </div>
  }

  if (displayDate) {
    date = <time>{post.formatted_date}</time>
  }

  return (
    <article id={`${postType}-${post.id}`} className="eight29-post eight29-post-card">
      <a href={post.link} className="eight29-post-wrapper">
        {featuredImage}

        <div className="eight29-post-body">
          <div className="eight29-post-categories">
          {categoryItems}
          </div>

          <h4 className="eight29-post-title" dangerouslySetInnerHTML={{__html: post.title.rendered}}></h4>

          {excerpt}

          <div className="eight29-post-detail">
            {date}
            {author}
          </div>
        </div>
      </a>
    </article>
  );
}

export default post;